import http from "./http";

class FrequenceparutionsService {
    index(){
        return http.get("/api/frequenceparutions")
    }

    store(data,token){
        return http.post("/api/frequenceparutions/store", data,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    edit(id,token){
        return http.get(`/api/frequenceparutions/${id}/edit`,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    show(id,token){
        return http.get(`/api/frequenceparutions/${id}/show`,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    update(id, data,token){
        return http.post(`/api/frequenceparutions/${id}/update`, data,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    delete(id,token){
        return http.delete(`/api/frequenceparutions/${id}/delete`,{ headers: { 'Authorization': 'Bearer '+token } })
    }
}

export default new FrequenceparutionsService()